import { Box, styled } from '@mui/system';
import { BoxProps } from '@mui/material';

interface StyledBoxProps extends BoxProps {
    highlight?: boolean;
}

const TitleWithUnderline = styled(Box)<StyledBoxProps>(({ highlight = true, theme }) => ({
    position: 'relative',
    border: 0,
    borderBottom: 4,
    borderStyle: 'solid',
    borderColor: theme.palette.alpha.primary[3],
    wordBreak: 'break-all',

    ...(highlight && {
        '&:before': {
            content: '""',
            width: '30px',
            height: '4px',
            left: '0',
            bottom: '-4px',
            position: 'absolute',
            backgroundColor: theme.palette.info.main,
        },
    }),
}));

export default TitleWithUnderline;
